import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import Notification from "../Notification";
import JoinRequestDecisionMenuItems from "./JoinRequestDecisionMenuItems";
import { useJoinRequestDecision } from "../../custom-hooks/useJoinRequestDecision";
import { pendingJoinRequestIdForDetails } from "../../utils/joinRequestDecision";

/**
 * Action menu on the admin Assessment Details instance of a joining sponsor: Accept or
 * Reject its join request while it is pending. Renders nothing otherwise.
 */
export default function JoinRequestDecisionMenu({ joinDetails, onDecided }) {
  const [note, setNote] = useState({ show: false, message: "", status: "success" });
  const { accept, reject, isDeciding } = useJoinRequestDecision({
    notify: (message, status) => setNote({ show: true, message, status }),
    onDecided,
  });
  const joinRequestId = pendingJoinRequestIdForDetails(joinDetails);

  return (
    <>
      {joinRequestId ? (
        <Menu as="div" className="relative inline-block text-left">
          <Menu.Button className="inline-flex items-center justify-center rounded-md p-1.5 text-gray-500 hover:text-gray-600 focus:outline-none">
            <span className="sr-only">Join request actions</span>
            <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
          </Menu.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              anchor="bottom end"
              portal
              className="z-[100] mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none"
            >
              <JoinRequestDecisionMenuItems
                disabled={isDeciding}
                onAccept={() => accept(joinRequestId)}
                onReject={() => reject(joinRequestId)}
              />
            </Menu.Items>
          </Transition>
        </Menu>
      ) : null}
      <Notification
        setShow={(show) => setNote((prev) => ({ ...prev, show }))}
        show={note.show}
        status={note.status}
        errorMessage={note.message}
      />
    </>
  );
}
